export default __webpack_public_path__ + "static/media/fila-espera.902dbe25.mp3";